import { Trans } from "react-i18next"

import util from "utils/utils"

export default function Joined({ ownerGroup = { name: "Undefined" }, events }) {
  return (
    <Trans i18nKey="notifications.groupUserJoined">
      <b>{{ name: util.getEventNames(events) }}</b>
      joined your group
      <b>{{ group: ownerGroup.name }}</b>.
    </Trans>
  )
}
